<template>
  <div ref="settingDrawer" class="setting-drawer">
    <a-drawer
      width="300"
      placement="right"
      :closable="false"
      :visible="visible"
      :handle="handle"
      @close="onClose"
    >
      <div class="setting-drawer-index-content">
        <div>
          <h3 class="setting-drawer-index-title">整体风格设置</h3>
          <div class="setting-drawer-index-blockChecbox">
            <a-tooltip>
              <template slot="title"> 暗色菜单风格 </template>
              <div class="setting-drawer-index-item" @click="handleMenuTheme('dark')">
                <img
                  src="https://gw.alipayobjects.com/zos/rmsportal/LCkqqYNmvBEbokSDscrm.svg"
                  alt="dark"
                />
                <div v-if="navTheme === 'dark'" class="setting-drawer-index-selectIcon">
                  <a-icon type="check" />
                </div>
              </div>
            </a-tooltip>

            <a-tooltip>
              <template slot="title"> 亮色菜单风格 </template>
              <div class="setting-drawer-index-item" @click="handleMenuTheme('light')">
                <img
                  src="https://gw.alipayobjects.com/zos/rmsportal/jpRkZQMyYRryryPNtyIC.svg"
                  alt="light"
                />
                <div v-if="navTheme !== 'dark'" class="setting-drawer-index-selectIcon">
                  <a-icon type="check" />
                </div>
              </div>
            </a-tooltip>
          </div>
        </div>

        <!-- <div :style="{ marginBottom: '24px' }">
          <h3 class="setting-drawer-index-title">主题色</h3>

          <div style="height: 20px">
            <a-tooltip class="setting-drawer-theme-color-colorBlock"
              v-for="(item, index) in colorList"
              :key="index">
              <template slot="title">
                {{ item.key }}
              </template>
              <a-tag :color="item.color"
                @click="changeColor(item.color)">
                <a-icon type="check"
                  v-if="item.color === primaryColor"></a-icon>
              </a-tag>
            </a-tooltip>

          </div>
        </div> -->
        <a-divider />
        <div>
          <h3 class="setting-drawer-index-title">导航模式</h3>
          <div class="setting-drawer-index-blockChecbox">
            <a-tooltip>
              <template slot="title"> 侧边栏导航 </template>
              <div class="setting-drawer-index-item" @click="handleLayout('sidemenu')">
                <img
                  src="https://gw.alipayobjects.com/zos/rmsportal/JopDzEhOqwOjeNTXkoje.svg"
                  alt="sidemenu"
                />
                <div v-if="layoutMode === 'sidemenu'" class="setting-drawer-index-selectIcon">
                  <a-icon type="check" />
                </div>
              </div>
            </a-tooltip>

            <a-tooltip>
              <template slot="title"> 顶部栏导航 </template>
              <div class="setting-drawer-index-item" @click="handleLayout('topmenu')">
                <img
                  src="https://gw.alipayobjects.com/zos/rmsportal/KDNDBbriJhLwuqMoxcAr.svg"
                  alt="topmenu"
                />
                <div v-if="layoutMode !== 'sidemenu'" class="setting-drawer-index-selectIcon">
                  <a-icon type="check" />
                </div>
              </div>
            </a-tooltip>
          </div>
          <div>
            <a-list :split="false" size="small">
              <a-list-item>
                <a-tooltip slot="actions">
                  <template slot="title"> 该设定仅 [顶部栏导航] 时有效 </template>
                  <a-select
                    size="small"
                    style="width: 80px"
                    :default-value="contentWidth"
                    @change="handleContentWidthChange"
                  >
                    <a-select-option value="Fixed">固定</a-select-option>
                    <a-select-option v-if="layoutMode !== 'sidemenu'" value="Fluid"
                      >流式</a-select-option
                    >
                  </a-select>
                </a-tooltip>
                <a-list-item-meta>
                  <div slot="title">内容区域宽度</div>
                </a-list-item-meta>
              </a-list-item>
              <a-list-item>
                <a-switch
                  slot="actions"
                  size="small"
                  :default-checked="fixedHeader"
                  @change="handleFixedHeader"
                />
                <a-list-item-meta>
                  <div slot="title">固定 Header</div>
                </a-list-item-meta>
              </a-list-item>
              <a-list-item>
                <a-switch
                  slot="actions"
                  size="small"
                  :disabled="!fixedHeader"
                  :default-checked="autoHideHeader"
                  @change="handleFixedHeaderHidden"
                />
                <a-list-item-meta>
                  <a-tooltip slot="title" placement="left">
                    <template slot="title">固定 Header 时可配置</template>
                    <div :style="{ opacity: !fixedHeader ? '0.5' : '1' }">下滑时隐藏 Header</div>
                  </a-tooltip>
                </a-list-item-meta>
              </a-list-item>
              <a-list-item>
                <a-switch
                  slot="actions"
                  size="small"
                  :disabled="layoutMode === 'topmenu'"
                  :default-checked="fixSiderbar"
                  @change="handleFixSiderbar"
                />
                <a-list-item-meta>
                  <div
                    slot="title"
                    :style="{ textDecoration: layoutMode === 'topmenu' ? 'line-through' : 'unset' }"
                  >
                    固定侧边菜单
                  </div>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </div>
        </div>
        <a-divider />

        <div>
          <h3 class="setting-drawer-index-title">其他设置</h3>
          <div>
            <a-list :split="false" size="small">
              <a-list-item>
                <a-switch
                  slot="actions"
                  size="small"
                  :default-checked="colorWeak"
                  @change="onColorWeak"
                />
                <a-list-item-meta>
                  <div slot="title">色弱模式</div>
                </a-list-item-meta>
              </a-list-item>
              <a-list-item>
                <a-switch
                  slot="actions"
                  size="small"
                  :default-checked="multiTab"
                  @change="onMultiTab"
                />
                <a-list-item-meta>
                  <div slot="title">多页签模式</div>
                </a-list-item-meta>
              </a-list-item>
              <a-list-item>
                <a-switch
                  slot="actions"
                  size="small"
                  :default-checked="searchMenu"
                  @change="onSearchMenu"
                />
                <a-list-item-meta>
                  <div slot="title">菜单搜索</div>
                </a-list-item-meta>
              </a-list-item>
              <a-list-item>
                <a-switch
                  slot="actions"
                  size="small"
                  :default-checked="permission"
                  @change="onPermission"
                />
                <a-list-item-meta>
                  <div slot="title">权限检查(不支持实时)</div>
                </a-list-item-meta>
              </a-list-item>
              <a-list-item>
                <a-switch
                  slot="actions"
                  size="small"
                  :default-checked="navMenu"
                  @change="onNavMenu"
                />
                <a-list-item-meta>
                  <div slot="title">顶部菜单</div>
                </a-list-item-meta>
              </a-list-item>
              <a-list-item>
                <a-switch
                  slot="actions"
                  size="small"
                  :default-checked="showChangeColor"
                  @change="onIsChangeColor"
                />
                <a-list-item-meta>
                  <div slot="title">更换主题色</div>
                </a-list-item-meta>
              </a-list-item>
              <a-list-item>
                <a-switch
                  slot="actions"
                  size="small"
                  :default-checked="showChangeLanguage"
                  @change="onIsChangeLanguage"
                />
                <a-list-item-meta>
                  <div slot="title">多语言</div>
                </a-list-item-meta>
              </a-list-item>
              <a-list-item>
                <a-switch
                  slot="actions"
                  size="small"
                  :default-checked="showTips"
                  @change="onShowTips"
                />
                <a-list-item-meta>
                  <div slot="title">显示通知</div>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </div>
        </div>
        <a-divider />
        <div>
          <a-button icon="copy" block @click="doCopy">拷贝设置</a-button>
          <a-alert type="warning" :style="{ marginTop: '24px' }">
            <span slot="message">
              配置栏只在开发环境用于预览，生产环境不会展现，请手动修改配置文件
              <a
                href="https://github.com/sendya/ant-design-pro-vue/blob/master/src/config/defaultSettings.js"
                target="_blank"
                >src/config/defaultSettings.js</a
              >
            </span>
          </a-alert>
        </div>
      </div>
      <div class="setting-drawer-index-handle" @click="toggle">
        <a-icon v-if="!visible" type="setting" />
        <a-icon v-else type="close" />
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { mixin, mixinDevice } from '@/utils/mixin';

export default {
  components: {
    // DetailList,
    // SettingItem,
  },
  mixins: [mixin, mixinDevice],
  data() {
    return {
      visible: false,
      handle: <div />,
    };
  },
  watch: {},
  mounted() {},
  methods: {
    showDrawer() {
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    toggle() {
      this.visible = !this.visible;
    },
    onColorWeak(checked) {
      this.$store.dispatch('system/app/ToggleWeak', checked);
    },
    onMultiTab(checked) {
      this.$store.dispatch('system/app/ToggleMultiTab', checked);
    },
    onSearchMenu(checked) {
      this.$store.dispatch('system/app/ToggleSearchMemu', checked);
    },
    onPermission(checked) {
      this.$store.dispatch('system/app/TogglePermission', checked);
    },
    onNavMenu(checked) {
      this.$store.dispatch('system/app/ToggleNavMenu', checked);
    },
    onIsChangeColor(checked) {
      this.$store.dispatch('system/app/ToggleShowChangeColor', checked);
    },
    onIsChangeLanguage(checked) {
      this.$store.dispatch('system/app/ToggleShowChangeLanguage', checked);
    },
    onShowTips(checked) {
      this.$store.dispatch('system/app/ToggleShowTips', checked);
    },

    handleMenuTheme(theme) {
      this.$store.dispatch('system/app/ToggleTheme', theme);
    },
    doCopy() {
      // get current settings from mixin or this.$store.state.app, pay attention to the property name
      const text = `export default {
  primaryColor: '${this.primaryColor}', // primary color of ant design
  navTheme: '${this.navTheme}', // theme for nav menu
  layout: '${this.layoutMode}', // nav menu position: sidemenu or topmenu
  sidebarOpened: true, // 默认左侧菜单是展开还是锁起来，true:展开
  contentWidth: '${this.contentWidth}', // layout of content: Fluid or Fixed, only works when layout is topmenu
  fixedHeader: ${this.fixedHeader}, // sticky header
  fixSiderbar: ${this.fixSiderbar}, // sticky siderbar
  autoHideHeader: ${this.autoHideHeader}, //  auto hide header
  colorWeak: ${this.colorWeak},
  multiTab: ${this.multiTab}, //  是否多tab页面
  searchMenu: ${this.searchMenu}, //  左侧菜单是否搜索
  navMenu: ${this.navMenu}, //  是否显示顶部菜单，顶部菜单是整个菜单数据第一层数据，针对层级和很大数据系统
  permission: ${this.permission}, //  权限与路由重新匹配，过滤掉无权限路由
  showChangeColor: ${this.showChangeColor}, // 允许更换颜色
  showChangeLanguage: ${this.showChangeLanguage}, // 允许切换语言
  showTips: ${this.showTips}, // 是否显示userMenu区域消息
  production: process.env.NODE_ENV === 'production' && process.env.VUE_APP_PREVIEW !== 'true',
  // vue-ls options
  storageOptions: {
    namespace: 'pro__',
    name: 'ls',
    storage: 'local',
  }
}`;
      this.$copyText(text)
        .then(() => {
          this.$message.success('复制完毕');
        })
        .catch((err) => {
          this.$message.error(`复制失败:${err.message}`);
        });
    },
    handleLayout(mode) {
      this.$store.dispatch('system/app/ToggleLayoutMode', mode);
      // 因为顶部菜单不能固定左侧菜单栏，所以强制关闭
      this.handleFixSiderbar(false);
    },
    handleContentWidthChange(type) {
      this.$store.dispatch('system/app/ToggleContentWidth', type);
    },
    changeColor(color) {
      if (this.primaryColor !== color) {
        this.$store.dispatch('system/app/ToggleColor', color);
      }
    },
    handleFixedHeader(fixed) {
      this.$store.dispatch('system/app/ToggleFixedHeader', fixed);
    },
    handleFixedHeaderHidden(autoHidden) {
      this.$store.dispatch('system/app/ToggleFixedHeaderHidden', autoHidden);
    },
    handleFixSiderbar(fixed) {
      if (this.layoutMode === 'topmenu') {
        this.$store.dispatch('system/app/ToggleFixSiderbar', false);
        return;
      }
      this.$store.dispatch('system/app/ToggleFixSiderbar', fixed);
    },
  },
};
</script>

<style lang="less" scoped>
@import '../index.less';
.setting-drawer-index-content {
  .setting-drawer-index-blockChecbox {
    display: flex;

    .setting-drawer-index-item {
      margin-right: 16px;
      position: relative;
      border-radius: 4px;
      cursor: pointer;

      img {
        width: 48px;
      }

      .setting-drawer-index-selectIcon {
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        padding-top: 15px;
        padding-left: 24px;
        height: 100%;
        color: @primary-color;
        font-size: 14px;
        font-weight: 700;
      }
    }
  }
  .setting-drawer-theme-color-colorBlock {
    width: 20px;
    height: 20px;
    border-radius: 2px;
    float: left;
    cursor: pointer;
    margin-right: 8px;
    padding-left: 0px;
    padding-right: 0px;
    text-align: center;
    color: #fff;
    font-weight: 700;

    i {
      font-size: 14px;
    }
  }
}

.setting-drawer-index-handle {
  position: absolute;
  top: 240px;
  background: @primary-color;
  width: 48px;
  height: 48px;
  right: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  pointer-events: auto;
  z-index: 1001;
  text-align: center;
  font-size: 16px;
  border-radius: 4px 0 0 4px;

  i {
    color: rgb(255, 255, 255);
    font-size: 20px;
  }
}
</style>
